import { useCallback } from "react";
import { useSelector } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { UnitId } from "../UnitId/UnitId";
import { UnitStateSelect } from "../../../../Helpers/StateAccessors/UnitStateSelect";

export function useUnitWidth(unitId: UnitId) {
    const unitWidthSelector = useCallback(
        (state: FullFormState) => UnitStateSelect.getUnitWidth(state, unitId),
        [unitId]
    );
    const unitWidth = useSelector(unitWidthSelector);

    return unitWidth;
}
